<template>
  <div class="message" v-loading="loading">
    <latestnews></latestnews>
    <div class="con">
      <top :title="'消息大厅'">
        <div>
          <a @click="toNewPage('/goods')" target="_blank" class="buy-btn">我要买</a>
          <a @click="toNewPage('/sold-acc')" target="_blank" class="sell-btn" v-if="userInfo">我要卖</a>
          <a @click="showLogin" target="_blank" class="sell-btn" v-else>我要卖</a>
        </div>
      </top>
      <table class="table">
        <tbody>
          <tr>
            <th>标题 </th>
            <th>内容 </th>
            <th>时间 </th>
            <th>操作</th>
          </tr>
          <tr v-for="item in mesList" v-bind:key="item.id" :class="{unread: item.status == 0}">
            <td style="width: 210px">{{item.title}}</td>
            <td class="content">
              <span>{{item.message}}</span>
            </td>
            <td style="width: 224px">{{item.created_at*1000 | formatDate}}</td>
            <td style="width: 80px" class="detail" @click="turnDetail(item)">查看详情</td>
          </tr>
          </tbody>
			</table>
      <div class="page">
        <div class="p-l">
          <p class="total">共{{page.total_count}}条记录,{{page.total_page}}页,每页{{page.page_size}}条记录</p>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page.page_current"
            :page-size="page.page_size"
            layout="prev, pager, next"
            :total="page.total_count"
            prev-text="上一页"
            next-text="下一页"
            >
          </el-pagination>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page.page_current"
          :page-size="page.page_size"
          layout="slot"
          :total="page.total_count"
          >
          <ul class="jumper">
            <li>每页显示:</li>
            <li v-for="item in sizes" v-bind:key="item.id" @click="handleSizeChange(item)">{{item}}</li>
          </ul>
        </el-pagination>
      </div>
    </div>

    <el-dialog title="收件详情" :visible.sync="sjFormVisible" custom-class="dialog-t" width="1011px">
      <item :data="select"></item>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sjFormVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import latestnews from '@/components/common/latestnews/latestNews'
import top from '@/components/common/top/top'
import item from '@/components/message/item'
import { mapState, mapMutations } from 'vuex'
import { messageResource, userResource } from '@/resource/resource'
import { formatDate } from '@/common/js/common'
import { deleteCookie } from '@/common/js/cookies'

const ERR_OK = 0

export default {
  name: 'message',
  data () {
    return {
      mesList: [],
      page: {
        'page_current': 1,
        'page_size': 20,
        'total_count': 0,
        'total_page': 1
      },
      select: {},
      sjFormVisible: false,
      sizes: [20, 50, 100, 200],
      loading: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'logined'])
  },
  created () {
    this.getMesList()
  },
  methods: {
    handleSizeChange(size) {
      // console.log(`每页 ${val} 条`)
      this.page.page_size = size
      this.getMesList({count: this.page.page_size})
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.getMesList({count: this.page.page_size, page: val - 1})
    },
    getMesList (params) {
      this.loading = true
      messageResource.list(params).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.mesList = res.data
          this.page = res.page
        }
      })
    },
    turnDetail(data) {
      this.select = data
      if (data.status === 0) {
        this.readMes(data.id)
      }
      this.sjFormVisible = true
    },
    readMes(id) {
      messageResource.read({id: id}).then(res => {
        res = res.body
        if (res.errcode === ERR_OK) {
          this.mesList.map(data => {
            if (data.id === id) {
              data.status = 1
              this.getUserInfo()
            }
          })
        } else {
          this.mesList.map(data => {
          if (data.id === id) {
            data.status = 1
            this.getUserInfo()
          }
        })
        }
      })
    },
    getUserInfo () {
      userResource.info().then(response => {
        response = response.body
        if (response.errcode === ERR_OK) {
          this.AUTO_USERINFO(response.data)
        } else {
          deleteCookie('isLogined')
        }
      })
    },
    showLogin() {
      this.$emit('showlogin', true)
    },
    toNewPage(url) {
      window.open(window.location.origin + url)
    },
    ...mapMutations([
        'AUTO_USERINFO'
    ])
  },
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    }
  },
  components: {
    latestnews,
    top,
    item
  }
}
</script>

<style lang="stylus" scoped>
.message
  width 1000px
  margin 0 auto
  .con
    .table
      width 100%
      // table-layout fixed
      th
        line-height 40px
        background #efefef
        white-space nowrap
        color #626262
        text-align center
        font-size 14px
        font-weight normal
        border solid 1px #dcdcdc
        position relative
      td
        line-height 40px
        background #fff
        white-space nowrap
        color #626262
        text-align center
        font-size 14px
        font-weight normal
        border solid 1px #dcdcdc
        border-top none
        position relative
        &.detail
          color #ff4800
          text-decoration underline
          cursor pointer
        &.content
          width 490px
          & > span
            display block
            width 490px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
      tr:nth-child(odd) td
        background #efefef
      .unread
        td
          font-weight bold
    .page
      border solid 1px #dcdcdc
      border-top none
      display flex
      align-items center
      justify-content space-between
      height 42px
      .p-l
        display flex
        .total
          height 30px
          border solid 1px #dcdcdc
          padding 0 10px
          color #626262
          font-size 14px
          line-height 30px
          margin-left 5px
</style>



// WEBPACK FOOTER //
// message.vue?7e746081